import axios from "axios";
import { useEffect, useRef, useState } from "react";
import { NotificationManager } from "react-notifications";
import Select from "react-select";
import dollor from "../../../assets/icons/dollar.svg";
import SearchDropdown from "../../../components/Dropdowns/SearchDropdown";
import InputWithIcon from "../../../components/InputWithIcon";
import useAuth from "../../../hooks/useAuth";
import { BASE_URL } from "../../../utils/Element";

const AddpipelineData = ({
  addpipelineData,
  onSetAddpipelineData,
  handleSubmit,
  showModal,
  handleChange,
  onClose,
  error,
  from,
}) => {
  const [bdsOptions, setBdsOptions] = useState([]);
  const [contactOptions, setContactOptions] = useState([]);
  const [transactionOptions, setTransactionOptions] = useState([]);
  const [stageOptions, setStageOptions] = useState([]);
  const selectRef = useRef(null);
  const [config] = useAuth();

  const fetchUsers = (listType) => {
    axios
      .get(`${BASE_URL}/get-datalisting?list=${listType}`, config)
      .then((res) => {
        const data = res?.data?.data;

        const userOptions =
          data?.users?.map((el) => ({
            value: el?.id,
            label: `${el?.first_name} ${el?.last_name}`,
            role: el?.role_id,
          })) || [];

        const transactionOptionsList =
          data?.transaction_type?.map((el) => ({
            value: el?.id,
            label: el?.name,
          })) || [];

        const stageOptionsList =
          data?.stage?.map((el) => ({
            value: el?.id,
            label: el?.name,
          })) || [];

        switch (listType) {
          case "usersList&role_id=3":
            setBdsOptions(userOptions);
            break;
          case "transaction_type":
            setTransactionOptions(transactionOptionsList);
            break;
          case "stage":
            setStageOptions(stageOptionsList);
            break;
          default:
            break;
        }
      })
      .catch((err) => {
        if (
          err.response?.data?.message &&
          err.response?.data?.message !== "Too Many Attempts."
        ) {
          NotificationManager.error(err.response?.data?.message);
        }
      });
  };

  useEffect(() => {
    if (showModal) {
      fetchUsers("usersList&role_id=3");
      fetchUsers("transaction_type");
      fetchUsers("stage");
    }
  }, [showModal]);

  const fetchSuggestions = (inputValue) => {
    if (inputValue !== "") {
      axios
        .get(
          `${BASE_URL}/get-datalisting?list=contacts&search=${inputValue}`,
          config
        )
        .then((res) => {
          const data = res?.data?.data;
          const contactOptionsList =
            data?.contact_list?.map((el) => ({
              value: el?.id,
              label: `${el?.first_name} ${el?.last_name}`,
            })) || [];
          setContactOptions(contactOptionsList);
        })
        .catch((err) => {
          if (
            err.response?.data?.message &&
            err.response?.data?.message !== "Too Many Attempts."
          ) {
            NotificationManager.error(err.response?.data?.message);
          }
        });
    } else {
      setContactOptions([]);
    }
  };

  // ✅ FIXED: Proper state update
  const handleGCIChange = (e) => {
    const value = e.target.value;

    onSetAddpipelineData((prev) => {
      const gciAmount = parseFloat(value) || 0;

      return {
        ...prev,
        potential_gcl: value,
        potential_advisor_commission: (gciAmount * 0.5).toFixed(2),
      };
    });
  };

  return (
    <div>
      <form className="contact-form pr-4" onSubmit={handleSubmit}>
        {from === "pipeline" && (
          <>
            <div>
              <label className="dark-H head-4 mb-2">
                Associate<span className="red-D">*</span>
              </label>
              <Select
                ref={selectRef}
                className="body-N"
                options={bdsOptions}
                placeholder="Select"
                value={
                  bdsOptions.find(
                    (option) =>
                      option?.value === addpipelineData?.associate_id
                  ) || null
                }
                onChange={(option) =>
                  handleChange(option?.value, "associate_id")
                }
              />
              {error?.associate_id && (
                <p className="body-S red-D pt-1">
                  {error?.associate_id}
                </p>
              )}
            </div>

            <div className="mt-4">
              <label className="dark-H head-4 mb-2">
                Contact Name<span className="red-D">*</span>
              </label>
              <SearchDropdown
                isTop={false}
                placeholder="Search Here..."
                text={addpipelineData?.contact_name}
                options={contactOptions}
                fetchSuggestions={fetchSuggestions}
                onSetOptions={(value) => setContactOptions(value)}
                handleSelect={(option) => {
                  onSetAddpipelineData({
                    ...addpipelineData,
                    contact_name: option?.label,
                    contact: option?.value,
                  });
                  setContactOptions([]);
                }}
              />
              {error?.contact_id && (
                <p className="body-S red-D pt-1">
                  {error?.contact_id}
                </p>
              )}
            </div>

            <div className="mt-4">
              <label className="dark-H head-4">
                Transaction Type
              </label>
              <div className="mt-3">
                <Select
                  options={transactionOptions}
                  className="body-N"
                  value={
                    transactionOptions.find(
                      (option) =>
                        option.value ===
                        addpipelineData?.transaction_type
                    ) || null
                  }
                  onChange={(selectedOption) =>
                    handleChange(
                      selectedOption?.value,
                      "transaction_type"
                    )
                  }
                  placeholder="Select transaction type"
                />
              </div>
            </div>
          </>
        )}

        <div className="mt-4">
          <label className="dark-H head-4">Stage</label>
          <div className="mt-3">
            <Select
              options={stageOptions}
              className="body-N"
              value={
                stageOptions.find(
                  (option) =>
                    option.value === addpipelineData?.stage
                ) || null
              }
              onChange={(option) =>
                handleChange(option?.value, "stage")
              }
              placeholder="Select stage type"
            />
          </div>
        </div>

        {/* ✅ Potential GCI */}
        <div className="mt-4">
          <label className="dark-H head-4 mb-2">
            Potential GCI
          </label>
          <InputWithIcon
            icon={dollor}
            className="body-N"
            name="potential_gcl"
            type="number"
            placeholder="Write Potential GCI Here"
            value={addpipelineData?.potential_gcl ?? ""}
            onChange={handleGCIChange}
            step="0.01"
            min="0"
          />
          {error?.potential_gcl && (
            <p className="body-S red-D pt-1">
              {error?.potential_gcl}
            </p>
          )}
        </div>

        {/* ✅ Advisor Commission */}
        <div className="mt-4">
          <label className="dark-H head-4 mb-2">
            Potential Advisor Commission
          </label>
          <InputWithIcon
            icon={dollor}
            className="body-N"
            name="potential_advisor_commission"
            type="number"
            placeholder="Write Potential Advisor Commission Here"
            value={
              addpipelineData?.potential_advisor_commission ?? ""
            }
            onChange={(e) =>
              handleChange(
                e.target.value,
                "potential_advisor_commission"
              )
            }
            step="0.01"
            min="0"
          />
          {error?.potential_advisor_commission && (
            <p className="body-S red-D pt-1">
              {error?.potential_advisor_commission}
            </p>
          )}
        </div>

        <div className="mt-6">
          <button
            type="submit"
            className="save-button light-L head-5 green-bg-H"
          >
            Save
          </button>
          <button
            type="button"
            onClick={onClose}
            className="green-H ml-5"
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddpipelineData;